import { useCallback, useEffect } from "react"


const useEscape = (setIsTriggered, otherStates=[], otherStateValues=[], pending) => {
    // params {clearValues: the setState functions for the values,
//              valueTypes: the data types for the values} 
    const escFunction = useCallback((e) => {
        if (e.key === "Escape" && !pending) {
            setIsTriggered(false)
            if (otherStates.length !==0 && otherStateValues.length !== 0) {
                otherStates.forEach((val, index) => {
                    val(otherStateValues[index])
                })
            }
        }
    }, [otherStateValues, otherStates, setIsTriggered, pending])

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false)

        return () => {
            document.removeEventListener("keydown", escFunction, false)
        }
    }, [escFunction])

    return { escFunction }
}

export {useEscape}